import ProfileDropdown from '@/components/Header/ProfileDropdown';
import SettingsIcon from '@/components/Header/SettingsIcon';
import NotificationsDropdown from './Notifications';
import ThemeToggle from '../Helper/ThemeToggle';
import { SidebarTrigger } from '@/components/ui/sidebar';
import Logo from "@/assets/svg/logo.svg"

export default function Header() {
  return (
    <>
      <header className="bg-transparent px-3 py-3 lg:px-[2rem] flex items-center justify-between">
        {/* Left side - 50% width on mobile */}
        <div className="flex items-center space-x-4 w-1/2 lg:w-auto">
          <SidebarTrigger className="[&>svg]:!h-[3rem] [&>svg]:!w-[3rem]" />
        </div>

        {/* Mobile Logo - centered */}
        <div className="logo lg:hidden flex justify-center absolute left-1/2 transform -translate-x-1/2">
          <img className="w-[12rem]" src={Logo} alt="" />
        </div>

        {/* Right side - 50% width on mobile */}
        <div className="flex items-center gap-[0.8rem] md:gap-[1.2rem] lg:gap-[1.5rem] w-1/2 lg:w-auto justify-end">
          {/* Theme Toggle */}
          <ThemeToggle size={20} />

          {/* Profile Dropdown */}
          <ProfileDropdown />

          {/* Setting */}
          <SettingsIcon />

          {/* Notifications Dropdown */}
          <NotificationsDropdown />
        </div>
      </header>
    </>
  );
}
